import React from "react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';

const setupPayload = (q = {}, r = -1) => {
    const question = {...q};
    question.result = r;
    return question;
};

const Question = ({question = {}, setQuestionResult = f => f, isLoading = false}) => (
    <Row className={"test-question mt-4"}>
        <Col md={{size: 12}} lg={{size:7}} xl={{size:8}}>
            <h5 className={"ml-2"}># {(question.id + 1) + ". " + question.question}</h5>
        </Col>
        <Col md={{size: 6, offset: 6}} lg={{size:5, offset: 0}} xl={{size:4, offset:0}}>
            <FormGroup className={"mr-4"}>
                <Label for="result">Степен *</Label>
                <Input disabled={isLoading} className={"bg-dark text-white"} type="select" name="select" id="result" value={question.result} valid={question.result >= 0} invalid={question.result < 0} onChange={e => setQuestionResult(setupPayload(question, e.target.value))}>
                    <option value={-1}>Моля изберете</option>
                    <option value={0}>Изобщо не</option>
                    <option value={1}>В известна степен</option>
                    <option value={2}>Умерено</option>
                    <option value={3}>Много често</option>
                    <option value={4}>Изключително често</option>
                </Input>
            </FormGroup>
        </Col>
    </Row>
);

export default Question